export const addressSearchProviderType = {
  AutoAddress: "AutoAddress",
  PitneyBowes: "PitneyBowes",
};

export enum GammaMapLayerType {
  Group,
  Composite,
  Style,
  SubGroup = 99,
}

export enum GammaMapLegendDisplayMode {
  Vertical,
  Horizontal,
}

export enum GammaMapLegendItemType {
  Fill,
  Line,
  Symbol,
  Circle,
  FillPattern,
}

export enum OrgMapType {
  OpenStreetMaps,
  OsiMaps,
  GoogleMaps,
  BingMaps,
  JbaLayer,
  CrimeLayer,
  FireLayer,
}
